/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const roleSchema = z.enum(['member', 'admin', 'jobillan', 'recruiter'])

export type RoleSchema = z.infer<typeof roleSchema>
